import React, { useEffect, useState, useRef, useContext } from "react"
import Loader from "react-loader-spinner"
import ReCAPTCHA from "react-google-recaptcha"
import { useForm } from "react-hook-form"
import { siteUrl } from "../../../shared/utils/siteUrl"

import { activitySEO } from "../../../constants/activity-constants"
import { Context } from "../../../context/app-context"
import * as reCaptchaKey from "../../../shared/constants/reCaptcha"
import sessionStorage from "./../../../utils/sessionStorage"
import { errMessageForm } from "./../../../utils/messagesUI"
import ModalInfo from "../modal-info/modal-info"

import "./modal-login.scss"

export default function ModalLogin(props) {
  const [session] = useState(new sessionStorage())
  const { dispatch } = useContext(Context)
  const recaptchaRef = useRef(null)
  const [authErrorMessage, setAuthErrorMessage] = useState(null)
  const [isLogin, setIsLogin] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors } = useForm()

  const onSubmit = data => {
    if (isLoading) return
    setIsLoading(true)
    session.authLogin({
      payload: {
        email: data.user,
        password: data.password,
        captcha: recaptchaRef.current.getValue()
      },
      handleSuccess: () => {
        setIsLogin(true)
      },
      handleError: res => {
        setAuthErrorMessage(res.userMessage)
        // setTimeout(() => {
        //   setAuthErrorMessage(null)
        // }, 4000000)
      },
      handleFinally: res => {
        setIsLoading(false)
        recaptchaRef.current.execute()
      }
    })
  }

  useEffect(() => {
    recaptchaRef.current.execute()
  }, [recaptchaRef])

  useEffect(() => {
    if (typeof window !== "undefined" && isLogin) {
      setIsLoading(true)
      session.authUserInfo({
        handleSuccess: res => {
          dispatch({
            type: "set-context",
            payload: {
              modalActive: null
            }
          })
          window.location.href = `${activitySEO.url}/juega`
        },
        handleError: () => {
          setIsLogin(false)
        },
        handleFinally: () => {
          setIsLoading(false)
        }
      })
    }
  }, [session, isLogin, dispatch])

  return (
    <>
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={reCaptchaKey.key}
      />
      {(authErrorMessage && (
        <ModalInfo
          {...{
            title: "¡Uuuups!",
            body: (
              <>
                <p className="family-H-Medium color-blue size-25">
                  La clave que ingresaste no es correcta, recuerda ingresarla
                  sin guiones ni espacios.
                </p>
                <button
                  className="btn-secondary--2"
                  onClick={() => setAuthErrorMessage(null)}
                >
                  ¡VUELVE A INTENTARLO!
                </button>
              </>
            )
          }}
        />
      )) || (
        <div className="modal-login">
          <div className="modal-login-container">
            <form
              className="modal-login-form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <p className="subtitulo">
                Si ya estás registrada en NosotrasOnline, <br /> ingresa tu
                usuario y contraseña.
              </p>
              <div className="modal-login-input-container">
                <label htmlFor="user">Usuario/Email:</label>
                <input
                  className="f-input-login"
                  ref={register({
                    required: true,
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
                  })}
                  name="user"
                />
                {errors.user && (
                  <span className="input-error">
                    {errMessageForm[errors.user.type]}
                  </span>
                )}
              </div>
              <div className="modal-login-input-container">
                <label htmlFor="password">Contraseña:</label>
                <input
                  className="f-input-login"
                  ref={register({ required: true, minLength: 3 })}
                  type="password"
                  name="password"
                />
                {errors.password && (
                  <span className="input-error">
                    {errMessageForm[errors.password.type]}
                  </span>
                )}
              </div>
              <div className="modal-login-row">
                <a
                  className="link-to-remember-password f-concentrate-login-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={siteUrl + "/login/recuperar/"}
                >
                  ¿Olvidaste tu contraseña?
                </a>
              </div>
              <div className="modal-login-row">
                {(isLoading && (
                  <Loader
                    type="TailSpin"
                    color="#ffffff"
                    height={30}
                    width={30}
                  />
                )) || (
                  <button
                    className="f-btn-submit-login btn-secondary--2"
                    type="submit"
                  >
                    ENVIAR
                  </button>
                )}
              </div>
              <div className="modal-login-row">
                {" "}
                <a
                  className="link-to-register f-concentrate-login-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={siteUrl + "/registro/"}
                >
                  QUIERO REGISTRARME
                </a>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
